export type Inbox = {
    id: string;
    from: string;
    subject: string;
    fileName: string;
    created: string;
    createdBy: string;
};
